/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type BulkUnpairZteEnrolmentsMutationVariables = Types.Exact<{
  input: Types.ZteBulkUnpairInput;
}>;


export type BulkUnpairZteEnrolmentsMutation = { __typename: 'Mutation', bulkUnpairZteEnrolments: { __typename: 'ZteBulkUnpairPayload', enrolments: Array<{ __typename: 'ZteEnrolment', id: string }> } };


export const BulkUnpairZteEnrolmentsDocument = gql`
    mutation bulkUnpairZteEnrolments($input: ZteBulkUnpairInput!) {
  bulkUnpairZteEnrolments(input: $input) {
    enrolments {
      id
    }
  }
}
    `;
export type BulkUnpairZteEnrolmentsMutationFn = ApolloReactCommon.MutationFunction<BulkUnpairZteEnrolmentsMutation, BulkUnpairZteEnrolmentsMutationVariables>;

/**
 * __useBulkUnpairZteEnrolmentsMutation__
 *
 * To run a mutation, you first call `useBulkUnpairZteEnrolmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnpairZteEnrolmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnpairZteEnrolmentsMutation, { data, loading, error }] = useBulkUnpairZteEnrolmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUnpairZteEnrolmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUnpairZteEnrolmentsMutation, BulkUnpairZteEnrolmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUnpairZteEnrolmentsMutation, BulkUnpairZteEnrolmentsMutationVariables>(BulkUnpairZteEnrolmentsDocument, options);
      }
export type BulkUnpairZteEnrolmentsMutationHookResult = ReturnType<typeof useBulkUnpairZteEnrolmentsMutation>;
export type BulkUnpairZteEnrolmentsMutationResult = ApolloReactCommon.MutationResult<BulkUnpairZteEnrolmentsMutation>;
export type BulkUnpairZteEnrolmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUnpairZteEnrolmentsMutation, BulkUnpairZteEnrolmentsMutationVariables>;